export enum StatutColis {
  CREE = 'cree',
  EN_ATTENTE_RAMASSAGE = 'en_attente_ramassage',
  RAMASSE = 'ramasse',
  EN_TRANSIT = 'en_transit',
  ARRIVE = 'arrive',
  AFFECTE_LIVREUR = 'affecte_livreur',
  EN_LIVRAISON = 'en_livraison',
  LIVRE = 'livre',
  LIVRAISON_ECHOUEE = 'livraison_echouee',
  RETOUR_EN_COURS = 'retour_en_cours',
  RETOURNE = 'retourne',
  ANNULE = 'annule',
  EN_DEDOUANEMENT = 'en_dedouanement',
  PRET_RETRAIT = 'pret_retrait',
  // Module E-Commerce (tenants ecommerce / ecommerce_structure uniquement)
  EN_PREPARATION = 'en_preparation',
  LIVREUR_SUR_PLACE = 'livreur_sur_place',
  INJOIGNABLE = 'injoignable',
  REPORTE = 'reporte',
  ADRESSE_INTROUVABLE = 'adresse_introuvable',
  ABSENT = 'absent',
  REFUSE = 'refuse',
  PAIEMENT_REFUSE = 'paiement_refuse',
}

export enum EtapeDouane {
  SGS = 'sgs',
  GUCE = 'guce',
  LIQUIDATION = 'liquidation',
  BON_A_ENLEVER = 'bon_a_enlever',
}

export enum ModePaiement {
  PAYE_ENVOI = 'paye_envoi',
  PAYE_RETRAIT = 'paye_retrait',
  PAIEMENT_LIVRAISON = 'paiement_livraison',
}

// Module Transport Interurbain National
export enum TypeService {
  ORDINAIRE = 'ordinaire',
  VIP = 'vip',
}

// Moyen de règlement (Particulier + Transport Interurbain) — distinct de
// ModePaiement qui régit QUAND on paie, pas COMMENT.
export enum MoyenPaiement {
  ESPECES = 'especes',
  MOBILE_MONEY = 'mobile_money',
  ORANGE_MONEY = 'orange_money',
  MTN_MONEY = 'mtn_money',
  COMPTE_MARCHAND = 'compte_marchand',
}

export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN_ENTREPRISE = 'admin_entreprise',
  AGENT_ORIGINE = 'agent_origine',
  AGENT_DESTINATION = 'agent_destination',
  LIVREUR = 'livreur',
  PARTICULIER = 'particulier',
  MANAGER_HUB = 'manager_hub',
  VENDEUR = 'vendeur',
}

export interface Colis {
  id: string;
  tracking_number: string;
  expediteur_nom?: string;
  expediteur_tel?: string;
  expediteur_ville?: string;
  expediteur_email?: string | null;
  expediteur_quartier?: string | null;
  destinataire_nom: string;
  destinataire_tel: string;
  destinataire_ville: string;
  destinataire_adresse?: string;
  destinataire_email?: string | null;
  canal_notification?: string | null;
  description_contenu: string;
  valeur?: number;
  poids_kg?: number;
  dimensions?: string;
  numero_bus?: string | null;
  photo_colis_url?: string;
  statut_actuel: StatutColis;
  etape_douane?: EtapeDouane | null;
  localisation_actuelle?: string;
  montant_total: number;
  // Détail article vs livraison (spéc. §9)
  montant_article?: number | null;
  montant_article_paye?: number;
  montant_livraison_paye?: number;
  // Expédition multi-colis (spéc. §8)
  expedition_id?: string | null;
  expedition_position?: number | null;
  // Livraison prévue vs effective (spéc. §10)
  date_livraison_prevue?: string | null;
  date_creation: string;
  date_livraison?: string;
  agent_origine?: {
    id: string;
    nom: string;
  };
  livreur?: {
    id: string;
    nom: string;
  };
  // Feature: Customer Rating
  note_client?: number | null;
  commentaire_client?: string | null;
  // Feature: Auto-Dispatch
  dispatch_auto?: boolean;
  // Feature: COD
  cod_montant?: number | null;
  cod_collecte?: boolean;
  cod_date_collecte?: string | null;
  // Mention financière (v1.1 §3.II)
  mode_paiement?: ModePaiement;
  // OTP de validation de livraison (v1.1 §3.II)
  otp_locked?: boolean;
  otp_valide_par_destinataire?: boolean;
  // Échec de délivrance de l'OTP sur tous les canaux (spéc. 28/09/26) —
  // condition d'ouverture de la validation sans code (voir ColisDetails.tsx).
  otp_delivery_failed?: boolean;
  otp_bypass_reason?: string | null;
  // Multisites — agence d'origine (v1.1 §4.I)
  agence_origine_id?: string | null;
  // Module Transport Interurbain National
  cni_passeport_expediteur?: string | null;
  livraison_domicile?: boolean;
  adresse_livraison_domicile?: string | null;
  type_service?: TypeService | null;
  agence_destination_id?: string | null;
  frais_transport_base?: number | null;
  frais_manutention?: number | null;
  frais_assurance?: number | null;
  // Module Particulier (livreur dédié)
  livreur_id?: string | null;
  expediteur_latitude?: number | null;
  expediteur_longitude?: number | null;
  destinataire_latitude?: number | null;
  destinataire_longitude?: number | null;
  // Module Transport Interurbain — frais de garde/magasinage
  frais_garde_montant?: number | null;
  // Module E-Commerce — incidents de livraison, vendeur, origine API
  date_reprogrammation?: string | null;
  motif_incident?: string | null;
  nb_tentatives?: number;
  livraison_type_paiement?: 'paye_sur_place' | 'prepaye' | null;
  merchant_id?: string | null;
  source?: string | null;
  external_ref?: string | null;
  // Module Transit Cargo International (spéc. MAJ 13/09)
  pays_origine?: string | null;
  type_fret?: string | null;
  volume_m3?: number | null;
  numero_lta?: string | null;
  aeroport_depart?: string | null;
  aeroport_arrivee?: string | null;
  longueur_cm?: number | null;
  largeur_cm?: number | null;
  hauteur_cm?: number | null;
  // Champs structurés partagés Particulier/Interurbain
  categorie?: string | null;
  mentions_manutention?: string[] | null;
  nombre_colis?: number;
  moyen_paiement?: MoyenPaiement | null;
  // Créneau de livraison souhaité par le destinataire (self-service, module
  // E-Commerce, spéc. 25/09/26) — 'matin' | 'apres_midi' | 'soir'.
  livraison_date_souhaitee?: string | null;
  livraison_creneau_souhaite?: 'matin' | 'apres_midi' | 'soir' | null;
  livraison_note_destinataire?: string | null;
  livraison_preference_maj_at?: string | null;
}

export interface DispatchRule {
  id: string;
  nom: string;
  actif: boolean;
  priorite: number;
  conditions: {
    villes_destination?: string[];
    poids_min?: number;
    poids_max?: number;
    valeur_min?: number;
    valeur_max?: number;
  };
  livreur_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface LivreurTransaction {
  id: string;
  tenant_id: string;
  livreur_id: string;
  type: 'cod_collecte' | 'reconciliation';
  colis_id: string | null;
  montant: number;
  notes: string | null;
  created_by: string | null;
  created_at: string;
}

export interface LivreurWallet {
  solde_cod: number;
  total_collecte: number;
  total_reconcilie: number;
}

export interface HistoriqueStatut {
  id: string;
  statut: string;
  localisation?: string;
  commentaire?: string;
  photo_url?: string;
  signature_url?: string;
  receptionnaire_nom?: string | null;
  etape_douane?: string;
  timestamp: string;
  user?: {
    nom: string;
  };
}
